import { render, staticRenderFns } from "./sampleInfo.vue?vue&type=template&id=34c4a9b0&scoped=true&"
import script from "./sampleInfo.vue?vue&type=script&lang=js&"
export * from "./sampleInfo.vue?vue&type=script&lang=js&"
import style0 from "./sampleInfo.vue?vue&type=style&index=0&id=34c4a9b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c4a9b0",
  null
  
)

export default component.exports